import type { HelpFile } from '../../types/help'
import { NotificationHistoryTestIds } from '../../../testids/NotificationHistoryTestIds'

export const notificationHistoryHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [NotificationHistoryTestIds.notificationHistoryTitle]:
      'Personal notification history — every notification the system has sent, with read status indicators.',
    [NotificationHistoryTestIds.colDate]: null,
    [NotificationHistoryTestIds.colEventType]: null,
    [NotificationHistoryTestIds.colMessage]: null,
    [NotificationHistoryTestIds.colReadIndicator]:
      'Read indicator — a coloured dot marks unread notifications; it disappears once the notification is opened.',
  },
}
